import { useRef } from 'react';
import { useInitialResults } from '../../hooks/useInitialResults';
import { useCalculatedHeight } from '../../hooks/useCalculatedHeight';
import SkeletonSummary from './skeletonSummary';
import './skeletonLoader.sass';

const GAP = 10;
const PADDING = 30;
const BUTTON_HEIGHT = 50;

/**
 * Componente de skeleton loading con shimmer effect
 * 
 * @description Proporciona una experiencia de carga mejorada mostrando
 * placeholders animados que simulan la estructura del contenido final.
 * Replica la estructura visual de Results + CardResults para una transición suave.
 * 
 * @component
 * @param {Object} props
 * @param {number} [props.count=4] - Número de skeleton items a mostrar
 * @returns {JSX.Element} Contenedor con skeleton items animados
 * @author Valeria Garcia
 */
export default function SkeletonLoader({ count = 4 }) {
  const gridRef = useRef(null);
  const INITIAL_RESULTS = useInitialResults();

  const calculatedMaxHeight = useCalculatedHeight(gridRef, INITIAL_RESULTS, {
    gap: GAP,
    padding: PADDING,
    extraHeight: BUTTON_HEIGHT,
  });

  const items = [];
  for (let i = 0; i < count; i++) {
    items.push(
      <div key={i} className="skeleton-grid-item">
        <div className="skeleton-card">
          <div className="skeleton-card-image-grid"></div>
          <div className="skeleton-card-content-grid">
            <div className="skeleton-line skeleton-line-category"></div>
            <div className="skeleton-line skeleton-line-title-grid"></div>
            <div className="skeleton-line skeleton-line-title-grid"></div>
            <div className="skeleton-line skeleton-line-title-grid short"></div>
            <div className="skeleton-line skeleton-line-date"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="skeleton-container">
      <SkeletonSummary />

      <section
        className="list-wrapper-results"
        style={{ maxHeight: calculatedMaxHeight ? `${calculatedMaxHeight}px` : 'auto', overflow: 'hidden', }}
      >
        <div
          ref={gridRef}
          id="resultados"
          className="skeleton-results skeleton-grid skeleton-border"
        >
          {/* <div className="skeleton-line skeleton-line-title-grid shortTitle"></div> */}

          {items}
        </div>
      </section>
    </div>
  );
}